// @flow

import styled, { css } from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export const MainPanel = styled.div`
  background: white;
  -webkit-font-smoothing: antialiased;
  @media screen and (min-width: 840px) {
    border-radius: 7px;
    ${theme.layout.raised && css`
      box-shadow: 0 1px 13px 0 rgba(76,76,76,0.15);
    `}
    ${theme.layout.bordered && css`
      border: 1px solid ${theme.colors.primary(67)};
    `}
  }
`;

export const MainPanelHeader = styled.header`
  background: ${theme.colors.neutral[100]};
  @media screen and (min-width: 840px) {
    padding-right: 16px;
    padding-left: 16px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
`;

export const MainPanelContent = styled.div``;
